import React, {useEffect} from 'react'
import styles from '../../Components/Profile/Profile.module.css';  // Import CSS Module styles
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from 'react-redux';
import Contact from '../../Components/Contact/Contact'
import { getOneUser } from '../../redux/Slices/users/thunk';

function ContactPage() {
    const { t, i18n } = useTranslation();
    const user = JSON.parse(localStorage.getItem('user'));
    const { oneUser } = useSelector((state) => state.usersSlice);

  const dispatch = useDispatch();
  useEffect(()=>{
    dispatch(getOneUser(user?.cln_key))
  },[])
  return (
    <div className='flex-grow-1'>
    <div className={styles.loginContainer}>
    <div className={styles.loginHeader}>{t("contact_with_admin")}</div>

      </div>
{ oneUser && <Contact oneUser={oneUser} />}
    </div>
  )
}
export default ContactPage;